import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Paper, CircularProgress } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    height: `calc(100vh - 94px)`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& > *': {
      marginBottom: theme.spacing(2),
    },
    textAlign: 'center',
  },
  icon: {
    fontSize: '5rem',
    color: theme.palette.error.main,
  },
}));

function LoadingPage() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Paper elevation={3} className={classes.paper}>
        <div>
          <CircularProgress />
        </div>
        <Typography variant="body1">
          Cargando datos...
        </Typography>
      </Paper>
    </div>
  );
}

export default LoadingPage;